import axios, { AxiosInstance } from 'axios';
import { API_TOKEN_STORAGE_KEY } from '@front-app/store/user_constants';
import { hasWindow } from '@front-app/util/env';

export const API_V1 = createTRApi(process.env.VUE_APP_API_V1_BASE_URL || '');

export const API_V2 = createTRApi(process.env.VUE_APP_API_V2_BASE_URL || '');

export const APP = axios.create({
	baseURL: process.env.VUE_APP_TRAPP_URL,
});

export const getAuthHeaders = (authToken: string): Record<string, string> => ({
	Authorization: `Basic ${authToken}`,
});

export const getAuthHeadersFromStorage = (): Record<string, string> => {
	const token = localStorage.getItem(API_TOKEN_STORAGE_KEY);
	if (token) {
		return getAuthHeaders(token);
	}
	return {};
};

/**
 * Factory function to create a TRAPP API instance that works for the V1 and V2
 * APIs
 *
 * @param baseURL The root URl for the API
 */
export function createTRApi(baseURL: string): AxiosInstance {
	const api = axios.create({
		baseURL,
		withCredentials: true,
		timeout: 15_000,
		headers: {
			Accept: 'application/json',
			'X-TR-API-Client': 'phoenix',
			'X-TR-API-Client-Version': process.env.VUE_APP_VERSION,
		},
	});

	api.defaults.headers.post['Content-Type'] = 'application/json';

	api.interceptors.request.use((config) => {
		// This is used in webworkers, so localStorage may not exist
		if (hasWindow()) {
			const authToken = window.localStorage.getItem(API_TOKEN_STORAGE_KEY);
			if (authToken) {
				// eslint-disable-next-line no-param-reassign
				config.headers = {
					...config.headers,
					...getAuthHeaders(authToken),
				};
			}
		}
		return config;
	});

	return api;
}
